import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import * as api from '../utils/api'
import config from "@/utils/config"
export default new Vuex.Store({
  state: {
    schoolInfo: {},
    // 切换整体导航
    a_index: 0,
    personInfo: {},
    token: localStorage.getItem('token'),
    globalType: '资源名称',
    globalKeyword: '',
    service: '',
    schoolId: '',
    navList: [
      {
        title: '首页',
        href: '/'
      },

      {
        title: '专业资源',
        href: '/resourceList?type=1'
      },
      {
        title: '精品资源',
        href: '/resourceList?type=2'
      },
      {
        title: '热门资源',
        href: '/resourceList?type=3'
      },
      {
        title: '资源中心',
        href: '/resourceList?type=4'
      },
      {
        title: '名师堂',
        href: '/teachHall'
      },
      {
        title: '新闻中心',
        href: '/newsInfo'
      },
      {
        title: '通知公告',
        href: '/noticeList'
      },
      {
        title: '帮助中心',
        href: '/helpCenter'
      }
    ],
  },
  getters: {
    schoolInfo: state => state.schoolInfo,
    a_index: state => state.a_index,
    navList: state => state.navList,
    token: state => state.token,
    personInfo: state => state.personInfo,
    globalType: state => state.globalType,
    globalKeyword: state => state.globalKeyword,
    service: state => state.service,
    schoolId: state => state.schoolId
  },
  mutations: {
    set_search(state, data) {
      state.globalType = data.globalType
      state.globalKeyword = data.globalKeyword
    },
    set_service(state, data) {
      state.service = data
    },
    set_nav_index(state, index) {
      localStorage.setItem('a_index', index)
      state.a_index = localStorage.getItem('a_index')
    },
    getSchoolInfo(state, data) {

      state.schoolInfo = data
    },
    getSchoolInfoId(state, data) {
      state.schoolId = data
    },
    set_token(state, token) {
      localStorage.setItem('token', token)
      state.token = localStorage.getItem('token')
    },
    set_user_info(state, data) {
      state.personInfo = data
    },
  },
  actions: {
    // 获取学校信息
    // getSchool({ commit }) {

    // },
    getSchoolId({ commit }) {
      api.getSchoolIdByDomain({
        dm:''
      }).then(res => {
        commit('getSchoolInfoId', res.data.id)
        api.getSchoolInFo({
          id: res.data.id
        }).then(res_s => {
          document.title = res_s.data.fullName
          commit('getSchoolInfo', res_s.data)
        })
// 获取访问量
        const visits = sessionStorage.getItem('visits')
        if (Number(visits) != 1) {
          api.statisticalData({
            organizeId: res.data.id,
            category: '门户访问'
          }).then(res_v => {
            if (res_v.code === 200) {
              sessionStorage.setItem('visits', 1)

            }
          })
        }

      })
    }

  }
})
